export const coreAppData = {
	appName: 'Calon Abdi Negara',
	colorPalletes: {
		primary: '#175493',
		secondary: '#F36206',
		burgerMenuBg: '#FFFFFF',
		contentBgColor: '#F9F9F9',
	},
	shortName: 'Cadira',
};
